export class NeptuneRestoreDestination {
    'region';
    'dbClusterIdentifier';
    'port';
    'dbClusterParameterGroup';
    'iamDbAuthenticationEnabled';
    'encryptionKey';
    'enableCloudwatchLogs';
    'tags';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "dbClusterIdentifier",
            "baseName": "dbClusterIdentifier",
            "type": "string",
            "format": ""
        },
        {
            "name": "port",
            "baseName": "port",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "dbClusterParameterGroup",
            "baseName": "dbClusterParameterGroup",
            "type": "string",
            "format": ""
        },
        {
            "name": "iamDbAuthenticationEnabled",
            "baseName": "iamDbAuthenticationEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "encryptionKey",
            "baseName": "encryptionKey",
            "type": "string",
            "format": ""
        },
        {
            "name": "enableCloudwatchLogs",
            "baseName": "enableCloudwatchLogs",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NeptuneRestoreDestination.attributeTypeMap;
    }
    constructor() {
    }
}
